import { AjaxService } from "../shared/services/AjaxService";
import { ResponseModel } from "../models/ResponseModel";

/* ================= DTO ================= */

export interface GetUpGradationDto {
    date: string; // yyyy-MM-dd
}

export interface UpGradationDto {
    upGradationId?: string | null;
    date: string;
    oneSeating: number;
    withoutOffence: number;
    dayStart: number;
    inJapaPrayers: number;
    japaSravan: number;
    comments?: string | null;
    marks: number;
}

export interface UpGradationHistoryFilterDto {
    userId?: string | null;
    fromDate: string;
    toDate: string;
}

/* ================= SERVICE ================= */

export const UpGradationService = {

    // 🔹 Get entry for date
    async getAgainstDate(date: string): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>(
            "/Upgradation/getUpGradationAgainstDate",
            { date }
        );
    },

    // 🔹 Create
    async create(payload: UpGradationDto): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>(
            "/Upgradation/create",
            payload
        );
    },

    // 🔹 Update
    async update(payload: UpGradationDto): Promise<ResponseModel> {
        return AjaxService.put<ResponseModel>(
            "/Upgradation/update",
            payload
        );
    },

    // 🔹 History
    async history(payload: UpGradationHistoryFilterDto): Promise<ResponseModel> {
        return AjaxService.post<ResponseModel>(
            "/Upgradation/getUpGradationHistory",
            payload
        );
    },

    // 🔹 Get single
    async get(upGradationId: string): Promise<ResponseModel> {
        return AjaxService.get<ResponseModel>(
            `/Upgradation/getUpGradation?upGradationId=${encodeURIComponent(upGradationId)}`
        );
    },

    // 🔹 Delete
    async delete(upGradationId: string): Promise<ResponseModel> {
        return AjaxService.delete<ResponseModel>(
            `/Upgradation/delete?upGradationId=${encodeURIComponent(upGradationId)}`
        );
    },
};